import React from "react";

const BuildCourageSummary = ({ selectedDrive, selectedExterior, selectedInterior, prices }) => {

  const formattedPrice = (value) =>
    value.toLocaleString("no-NO") + " kr";

  return (
    <div className="summary-wrapper">
      <div className="build-summary-card">

        <h3 className="summary-title">VOYAH COURAGE</h3>

        <p className="summary-price">{formattedPrice(prices[selectedDrive])}</p>

        <div className="summary-box">
          <p className="sum-label">Type</p>
          <p className="sum-value">
            {selectedDrive === "2wd" ? "Rear-wheel drive" : "Four-wheel drive"}
          </p>

          <p className="sum-label">Exterior</p>
          <p className="sum-value">{selectedExterior?.label || "Kumato Green"}</p>

          <p className="sum-label">Interior</p>
          <p className="sum-value">{selectedInterior?.label || "White / Grey"}</p>
        </div>

        <button className="order-btn">Go to order</button>

        <p className="summary-note">
          *Cost will vary with chosen color. Delivery charges may apply.
        </p>
      </div>
    </div>
  );
};

export default BuildCourageSummary;
